"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableRow = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledTableRow = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  height: 56px;\n  align-items: flex-start;\n\n  &:not(:last-of-type) {\n    border-bottom: 1px solid #d7dbdb;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  height: 56px;\n  align-items: flex-start;\n\n  &:not(:last-of-type) {\n    border-bottom: 1px solid #d7dbdb;\n  }\n"])));
var templateObject_1;
